import * as styles from './codeEditor.module.scss';
import { CodeEditorFeatures } from '../../CodeEditorFeatures';
export class CodeEditorController {
    static $inject = ['code', 'editorWasCreated', '$scope', 'onCodeEditorChange', 'onSaveSource', '$document'];
    constructor(code, // Used on view
    language, // Used to set this language
    close, editorWasCreated, $scope, onCodeEditorChange, onSaveSource, $document) {
        'ngInject';
        this.code = code;
        this.language = language;
        this.close = close;
        this.editorWasCreated = editorWasCreated;
        this.$scope = $scope;
        this.onCodeEditorChange = onCodeEditorChange;
        this.onSaveSource = onSaveSource;
        this.$document = $document;
        this.isMonacoLoading = true;
        this.init();
    }
    async init() {
        await this.checkFeatures();
        this.styles = styles;
        this.saved = true;
        this.editorLanguage = this.language ? this.language.toLowerCase() : 'javascript';
        this.fillLanguageDetails();
        const deregisterChangeTabEvent = this.$scope.$on('contentTabs:changeTab', () => {
            this.close();
        });
        let onKeyDownListenerBind = undefined;
        if (this.isCloseScriptTabEnabled) {
            onKeyDownListenerBind = this.onKeyDownEventHandler.bind(this);
            this.$document.on('keydown', onKeyDownListenerBind);
        }
        this.$scope.$on('$destroy', () => {
            deregisterChangeTabEvent();
            if (this.isCloseScriptTabEnabled) {
                this.$document.off('keydown', onKeyDownListenerBind);
            }
        });
        this.mouseOverTab = false;
        this.hasFocus = false;
    }
    async checkFeatures() {
        this.isCloseScriptTabEnabled = await CodeEditorFeatures.isCloseScriptTabEnabled();
    }
    onKeyDownEventHandler(event) {
        if (event.keyCode == 27 && !this.hasFocus) {
            this.close();
        }
    }
    fillLanguageDetails() {
        switch (this.editorLanguage) {
            case 'json':
                this.languageExtension = 'json';
                break;
            case 'plain text':
                this.languageExtension = 'txt';
                break;
            case 'xml':
                this.languageExtension = 'xml';
                break;
            case 'javascript':
            default:
                this.languageExtension = 'js';
                break;
        }
    }
    onCodeChange($event) {
        this.saved = false;
        this.$scope.$apply();
        this.onCodeEditorChange($event);
    }
    onSave() {
        this.saved = true;
        /**
         * Monaco dispatches an external event,
         * so we use $apply function to reflect changes on interface
         */
        this.$scope.$apply();
        this.onSaveSource();
    }
    didCreateEditor($event) {
        this.isMonacoLoading = false;
        this.editorWasCreated($event);
    }
    didFocusEditor() {
        this.hasFocus = true;
    }
    didBlurEditor() {
        this.hasFocus = false;
    }
    onEscape() {
        this.close();
    }
}
CodeEditorController.$inject = ['code', 'language', 'close', 'editorWasCreated', '$scope', 'onCodeEditorChange', 'onSaveSource', '$document'];
